"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = exports.EmptyModelError = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const immer_1 = require("immer");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
exports.EmptyModelError = new Error('Model error: value is empty, you must set current value before call "getValue"');
class Model {
    constructor(initialValue) {
        this.destroyed = false;
        this.subject = new rxjs_1.Subject();
        this.value = (0, immer_1.produce)(initialValue, () => { }) || null;
    }
    getValue() {
        if (!this.value) {
            throw exports.EmptyModelError;
        }
        return this.value;
    }
    update(updater) {
        if (this.destroyed) {
            return;
        }
        this.value = (0, immer_1.produce)(this.value, (draftValue) => {
            updater(draftValue);
        });
        if (this.value) {
            this.subject.next(this.value);
        }
    }
    setValue(value) {
        if (this.destroyed) {
            return;
        }
        this.value = (0, immer_1.produce)(value, () => { });
        this.subject.next(this.value);
    }
    asObservable() {
        return this.subject.asObservable().pipe((0, operators_1.map)(() => this.getValue()));
    }
    fieldChanges(key) {
        return this.asObservable().pipe((0, operators_1.startWith)(this.getValue()), (0, operators_1.map)(() => this.getValue()[key]), (0, operators_1.distinctUntilChanged)((left, right) => {
            if (left instanceof FileList) {
                return left === right;
            }
            return (0, fast_deep_equal_1.default)(left, right);
        }), (0, operators_1.scan)((acc, curr) => {
            return {
                value: curr,
                prevValue: acc.value
            };
        }, {}), (0, operators_1.skip)(1));
    }
    isEmpty() {
        return !this.value;
    }
    destroy() {
        this.subject.complete();
        this.value = null;
        this.destroyed = true;
    }
    subscribe(next, error, complete) {
        return this.subject.subscribe(next, error, complete);
    }
}
exports.Model = Model;
//# sourceMappingURL=Model.js.map